import { render, staticRenderFns } from "./AnswerImageInput.vue?vue&type=template&id=fdf24d30&scoped=true"
import script from "./AnswerImageInput.vue?vue&type=script&lang=js"
export * from "./AnswerImageInput.vue?vue&type=script&lang=js"
import style0 from "./AnswerImageInput.vue?vue&type=style&index=0&id=fdf24d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf24d30",
  null
  
)

export default component.exports